module.exports = __webpack_public_path__ + "img/ltd.b5dbb59a.png";